import List from "./List";
import Show from "./Detail";

export default {
  list: List,
  show: Show,
};
